function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import equals from 'ramda/src/equals';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import memoize from 'lodash/memoize';
import merge from 'ramda/src/mergeWith';
import propEq from 'ramda/src/propEq';
import i18n from 'invision-core/src/components/i18n/i18n';
import LocaleKeys from '../../../../../../../locales/keys';
var SelectableProductItemsController = /*#__PURE__*/function () {
  /**************************************************************
  * VIEW MODEL DEFINITION ('configuration' binding)
  * {
  *      items: [],
  *      mappedPricingPlanId: number, -- Pricing plan to show / allow (expects item.pricingPlans)
  *      showInstruction: boolean, -- Show selection instructions
  *      minQuantity: number, -- Min quantity allowed (0 for unvalidated / unrestricted)
  *      maxQuantity: number, -- Max quantity allowed (0 for unvalidated / unrestricted)
  *      usePlanSelection: boolean, -- Should show dropdown for plan selection
  *      showPurchasedPlans: boolean, -- Expects item.purchasedPlans
  *      usePerItemQuantity: boolean -- Use per-item pricing plan to define min/max quantities and allow quantity entry
  * }
  **************************************************************/

  function SelectableProductItemsController($filter) {
    _classCallCheck(this, SelectableProductItemsController);
    Object.assign(this, {
      $filter: $filter,
      LocaleKeys: LocaleKeys,
      viewModel: {
        instanceProperties: {},
        items: []
      },
      configurationItemsWithSingleSelectOptions: []
    });
  }
  return _createClass(SelectableProductItemsController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.modelCtrl.$validators['invalidSelectableItems'] = function (modelValue, viewValue) {
        return _this._validateSelection(modelValue, viewValue);
      };
      this._initializeViewModel();
      this._initializeConfigurationItemsWithSingleSelectOptions();
      this._mergeInstanceProperties();
      this._updateViewValueFromItemsCollection();
      this.modelCtrl.$commitViewValue();
    }
  }, {
    key: "_initializeViewModel",
    value: function _initializeViewModel() {
      if (!isNil(this.ngModel)) {
        this.viewModel = merge(this.viewModel, this.ngModel);
      } else {
        this.viewModel.items = clone(this.configuration.items.filter(propEq(true, 'isSelected')));
      }
    }
  }, {
    key: "_initializeConfigurationItemsWithSingleSelectOptions",
    value: function _initializeConfigurationItemsWithSingleSelectOptions() {
      var _this2 = this;
      var pp;
      this.configurationItemsWithSingleSelectOptions = this.configuration.items.map(function (item) {
        item.singleSelectOptions = Object.keys(item.pricingPlans).map(function (pricingPlanId) {
          pp = item.pricingPlans[pricingPlanId];
          return {
            isDiscounted: _this2._pricingPlanIsDiscounted(pp),
            pricingPlan: pp,
            pricingPlanId: pricingPlanId,
            selectableItem: item,
            selected: item.isSelected && equals(item.selectedPlanId, pricingPlanId) || false,
            text: ''
          };
        });
        if (item.singleSelectOptions && item.singleSelectOptions.length) {
          item.singleSelectOptions.unshift({
            text: i18n.translate(LocaleKeys.SELECT_WITH_ELLIPSIS)
          });
        }
        return item;
      });
    }
  }, {
    key: "_pricingPlanIsDiscounted",
    value: function _pricingPlanIsDiscounted(pricingPlan) {
      return (pricingPlan.discountedAmount || pricingPlan.discountedAmount === 0) && pricingPlan.discountedAmount !== pricingPlan.ChargeAmount;
    }
  }, {
    key: "_mergeInstanceProperties",
    value: function _mergeInstanceProperties() {
      var _this3 = this;
      if (this.viewModel.items && this.viewModel.items.length > 0) {
        this.viewModel.items.forEach(function (viewModelItem) {
          var match = _this3.configuration.items.find(function (inputItem) {
            return inputItem.product.Id === viewModelItem.product.Id;
          });
          if (!isNil(match) && !isNil(match.instanceProperties) && !isEmpty(match.instanceProperties)) {
            var currentProps = _this3.viewModel.instanceProperties[viewModelItem.product.Id] || {};
            _this3.viewModel.instanceProperties[viewModelItem.product.Id] = merge(match.instanceProperties, currentProps);
          }
        });
      }
    }
  }, {
    key: "_applyCurrencyFilter",
    value: function _applyCurrencyFilter(amount, currency) {
      return this.$filter('invCurrency')(amount, currency);
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      var _this4 = this;
      if (changesObj.configuration && !changesObj.configuration.isFirstChange()) {
        this._initializeConfigurationItemsWithSingleSelectOptions();
      }
      if (isNil(this.configuration.minQuantity)) {
        this.configuration.minQuantity = 0;
      }
      if (isNil(this.configuration.maxQuantity)) {
        this.configuration.maxQuantity = 0;
      }
      if (isNil(this.configuration.showInstruction)) {
        this.configuration.showInstruction = false;
      }
      if (isNil(this.configuration.items)) {
        this.configuration.items = [];
      }
      this.setInstructionalMessage();
      this._mergeInstanceProperties();

      //The configuration items change when "Show More" is clicked, need to resync with view model
      if (this.ngModel && this.ngModel.items && this.ngModel.items.length) {
        this.ngModel.items.forEach(function (item) {
          if (item.isSelected) {
            var match = _this4.configuration.items.find(function (targetItem) {
              return targetItem.product.Id === item.product.Id;
            });
            if (match) {
              match.selectedPlanId = item.selectedPlanId;
              match.isSelected = true;
            }
          }
        });
      }
      this.modelCtrl.$validate();
    }
  }, {
    key: "setInstructionalMessage",
    value: function setInstructionalMessage() {
      var _this5 = this;
      if (!this.configuration.showInstruction) {
        this.instructionalMessage = null;
        return;
      }

      //Create the memoized message function if it doesn't exist
      if (isNil(this._buildInstructionalMessage)) {
        this._buildInstructionalMessage = memoize(function (min, max) {
          if (_this5.configuration.items && _this5.configuration.items.length > 0) {
            var messageParams = {
              min: min,
              max: max
            };
            if (min === 0 && max === 0) {
              //No min or max
              _this5.instructionalMessage = i18n.translate(LocaleKeys.SELECTABLE_ITEMS.FROM);
            } else if (min > max) {
              //No max
              _this5.instructionalMessage = i18n.translate(LocaleKeys.SELECTABLE_ITEMS.AT_LEAST, messageParams);
            } else if (min === 0 && max > min) {
              //No min
              _this5.instructionalMessage = i18n.translate(LocaleKeys.SELECTABLE_ITEMS.AT_MOST, messageParams);
            } else if (min === max) {
              //Min and max are the same (exact number)
              _this5.instructionalMessage = i18n.translate(LocaleKeys.SELECTABLE_ITEMS.EXACTLY, messageParams);
            } else {
              //Both min and max
              _this5.instructionalMessage = i18n.translate(LocaleKeys.SELECTABLE_ITEMS.BETWEEN, messageParams);
            }
          } else {
            _this5.instructionalMessage = null;
          }
        });
      }
      this._buildInstructionalMessage(this.configuration.minQuantity, this.configuration.maxQuantity);
    }
  }, {
    key: "onItemSelection",
    value: function onItemSelection() {
      this._updateViewValueFromItemsCollection();
    }
  }, {
    key: "onSingleSelectPlanChange",
    value: function onSingleSelectPlanChange(singleSelectOptions, selectedPricingPlan) {
      singleSelectOptions.forEach(function (pricingPlan) {
        if (pricingPlan.selectableItem && pricingPlan.selectableItem.isSelected) {
          pricingPlan.selectableItem.isSelected = false;
          pricingPlan.selectableItem.selectedPlanId = null;
        }
      });
      if (selectedPricingPlan.selectableItem) {
        selectedPricingPlan.selectableItem.isSelected = true;
        selectedPricingPlan.selectableItem.selectedPlanId = selectedPricingPlan.pricingPlanId;
      }
      this._updateViewValueFromItemsCollection();
    }
  }, {
    key: "onSingleSelectPlanRemove",
    value: function onSingleSelectPlanRemove(deselectedPricingPlan) {
      deselectedPricingPlan.selectableItem.isSelected = false;
      deselectedPricingPlan.selectableItem.selectedPlanId = '';
      this._updateViewValueFromItemsCollection();
    }
  }, {
    key: "onQuantityChange",
    value: function onQuantityChange(selectableItem) {
      if (selectableItem.quantity === '' || selectableItem.quantity === null) {
        selectableItem.quantity = 0;
        selectableItem.isSelected = false;
      } else {
        var qty = Number(selectableItem.quantity);
        selectableItem.isSelected = qty > 0;
      }
      this._updateViewValueFromItemsCollection();
    }
  }, {
    key: "_updateViewValueFromItemsCollection",
    value: function _updateViewValueFromItemsCollection() {
      //One liner but called from multiple places.  Abstracted in case logic changes
      this.viewModel.items = clone(this.configuration.items.filter(propEq(true, 'isSelected')));
      this.modelCtrl.$setViewValue(this.viewModel);
      this.modelCtrl.$validate();
    }
  }, {
    key: "_validateSelection",
    value: function _validateSelection(modelValue, viewValue) {
      var value = modelValue || viewValue;
      var isValid = true;
      if (!isNil(value) && this.configuration.items && this.configuration.items.length > 0) {
        var min = this.configuration.minQuantity;
        var max = this.configuration.maxQuantity;
        if (min === 0 && max === 0) {
          isValid = true;
        } else {
          var selectedCount = value.items ? value.items.length : 0;
          if (min > 0 && selectedCount < min) {
            isValid = false;
          } else if (max > 0 && selectedCount > max) {
            isValid = false;
          } else {
            isValid = true;
          }
        }
      }
      return isValid;
    }
  }]);
}();
export default {
  template: require('./product.selectable.items.html'),
  controller: SelectableProductItemsController,
  require: {
    parentForm: '^^form',
    modelCtrl: 'ngModel'
  },
  bindings: {
    configuration: '<',
    disableCurrentInstanceProperties: '<?',
    ngModel: '<'
  }
};